import * as React from 'react';
import Button from '@mui/material/Button';
import { Stack, Typography } from '@mui/material';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import DirectoryFilter from '../../universal/DirectoryFilter';
import { images } from '../../../assets';
import DarkBtn from '../../universal/Buttons/DarkBtn';

// eslint-disable-next-line react/function-component-definition
export default function DirectoryMobileFilter({ filterstate, setFilterState }) {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Button onClick={handleClickOpen} sx={{ justifyContent: 'end' }}>
        <img src={images.filterIcon} alt="filter" className="filter_img " />
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="directory_dialog_box"
      >
        {/* <DialogTitle id="alert-dialog-title">
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography>Filter</Typography>
            <Stack direction="row" alignItems="center">
              <div className="font14px filter_text  clear_filter" role="button">
                Clear{' '}
              </div>
            </Stack>
          </Stack>
        </DialogTitle> */}
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <DirectoryFilter filterstate={filterstate} setFilterState={setFilterState} />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <DarkBtn title="Apply" onClick={handleClose} />
        </DialogActions>
      </Dialog>
    </>
  );
}
